// directives/mathHtml.js
import katex from 'katex'
import 'katex/dist/katex.min.css'

function renderMath(el) {
  el.querySelectorAll('span.math-tex').forEach(span => {
    // Skip if already rendered
    if (span.querySelector('.katex')) return

    const raw = span.textContent.trim()
    const latex = raw
      .replace(/^\\\(/, '').replace(/\\\)$/, '')
      .replace(/^\\\[/, '').replace(/\\\]$/, '')
      .trim()

    if (!latex) return

    try {
      katex.render(latex, span, {
        throwOnError: false,
        displayMode: raw.startsWith('\\['),
      })
    } catch (e) {
      console.warn('KaTeX render error:', e)
    }
  })
}

export default {

  'extended-html': {
    bind(el, binding) {
      // eslint-disable-next-line no-param-reassign
      el.innerHTML = binding.value || ''
      renderMath(el)
    },
    // Vue 2: "update" instead of "updated"
    update(el, binding) {
      if (binding.value !== binding.oldValue) {
        // eslint-disable-next-line no-param-reassign
        el.innerHTML = binding.value || ''
        renderMath(el)
      }
    },
  },

}

// // eslint-disable-next-line import/prefer-default-export
// export const vMathHtml = {
//   // Vue 2: "bind" instead of "beforeMount"
//   bind(el, binding) {
//     console.log(el)
//     // eslint-disable-next-line no-param-reassign
//     el.innerHTML = binding.value || ''
//     renderMath(el)
//   },
//   // Vue 2: "update" instead of "updated"
//   update(el, binding) {
//     console.log(el)
//     if (binding.value !== binding.oldValue) {
//       // eslint-disable-next-line no-param-reassign
//       el.innerHTML = binding.value || ''
//       renderMath(el)
//     }
//   },
// }
